import { render, staticRenderFns } from "./BalanceInfo.vue?vue&type=template&id=54e507b8&scoped=true&"
import script from "./BalanceInfo.vue?vue&type=script&lang=js&"
export * from "./BalanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./BalanceInfo.vue?vue&type=style&index=0&id=54e507b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e507b8",
  null
  
)

export default component.exports